var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pd-settings-view"},[_c('pd-settings-card',{staticClass:"mb-6"}),_c('ospi-number-card',{staticClass:"mb-6"}),_c('contracted-schedule-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }